module.exports = __webpack_public_path__ + "static/media/NotoSansThai.ccd28255.woff";